/* eslint-disable max-len */
import { createReducer } from 'reduxsauce';
import { Types } from './action';

const INITIAL_STATE = {
  isLoading: false,
  error: '',
  masterChecklistData: [],
  masterChecklisttMeta: [],
  masterChecklistSearchQueries: {},

  repoChecklistData: [],
  repoChecklistMeta: [],
  repoChecklistSearchQueries: {}
};

const getMasterChecklistStart = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: true
});
const getMasterChecklistSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  masterChecklisttMeta: action.payload.meta,
  masterChecklistData: action.payload.bulkList
});
const getMasterChecklistFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  error: action.payload.error
});

const getRepoChecklistStart = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: true
});
const getRepoChecklistSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  repoChecklistMeta: action.payload.meta,
  repoChecklistData: action.payload.bulkList
});
const getRepoChecklistFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  error: action.payload.error
});

const setMasterChecklistSearchQueries = (state = INITIAL_STATE, action) => ({
  ...state,
  masterChecklistSearchQueries: { ...action.payload }
});

const resetMasterChecklistSearchQueries = (state = INITIAL_STATE) => ({
  ...state,
  masterChecklistSearchQueries: INITIAL_STATE.masterChecklistSearchQueries
});

const setRepoChecklistSearchQueries = (state = INITIAL_STATE, action) => ({
  ...state,
  repoChecklistSearchQueries: { ...action.payload }
});

const resetRepoChecklistSearchQueries = (state = INITIAL_STATE) => ({
  ...state,
  repoChecklistSearchQueries: INITIAL_STATE.masterChecklistSearchQueries
});

const HANDLERS = {
  [Types.GET_MASTER_CHECKLIST_START]: getMasterChecklistStart,
  [Types.GET_MASTER_CHECKLIST_SUCCESS]: getMasterChecklistSuccess,
  [Types.GET_MASTER_CHECKLIST_FAILURE]: getMasterChecklistFailure,

  [Types.GET_REPO_CHECKLIST_START]: getRepoChecklistStart,
  [Types.GET_REPO_CHECKLIST_SUCCESS]: getRepoChecklistSuccess,
  [Types.GET_REPO_CHECKLIST_FAILURE]: getRepoChecklistFailure,

  [Types.SET_MASTER_CHECKLIST_SEARCH_QUERIES]: setMasterChecklistSearchQueries,
  [Types.RESET_MASTER_CHECKLIST_SEARCH_QUERIES]:
    resetMasterChecklistSearchQueries,

  [Types.SET_REPO_CHECKLIST_SEARCH_QUERIES]: setRepoChecklistSearchQueries,
  [Types.RESET_REPO_CHECKLIST_SEARCH_QUERIES]: resetRepoChecklistSearchQueries
};

export const checklistReducer = createReducer(INITIAL_STATE, HANDLERS);
